(() => {
 const init = (root = document) => root.querySelectorAll('[data-fm-book]:not([data-ready])').forEach(book => {
  book.dataset.ready = 'true';
  const panels = [...book.querySelectorAll('[data-book-panel]')], select = book.querySelector('[data-book-select]'), prev = book.querySelector('[data-book-prev]'), next = book.querySelector('[data-book-next]');
  let page = 1;
  const show = n => { page = Math.max(1, Math.min(panels.length, n)); panels.forEach((p, i) => p.hidden = i !== page - 1); select.value = String(page); prev.disabled = page === 1; next.disabled = page === panels.length; book.querySelector('[data-book-status]').textContent = `Page ${page} of ${panels.length}`; };
  book.querySelector('.book-toolbar').hidden = false;
  select.addEventListener('change', () => show(Number(select.value))); prev.addEventListener('click', () => show(page - 1)); next.addEventListener('click', () => show(page + 1)); show(1);
 });
 init(); document.addEventListener('shopify:section:load', e => init(e.target));
})();
